import React from 'react';
import {
  Grid,
  Box,
  Button
} from '@material-ui/core';
import { TextField } from '@material-ui/core';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { makeStyles } from '@material-ui/core/styles';
import DoseService from '../services/DoseService';

// Icônes Material-UI
import AddIcon from '@material-ui/icons/Add';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles((theme) => ({
  formContainer: {
    marginTop: theme.spacing(1),
  },
  gridItem: {
    padding: theme.spacing(1),
  },
  iconAdornment: {
    color: '#226D68',
    marginRight: theme.spacing(1),
  },
  submitButton: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    color: 'white',
    fontWeight: 600,
    fontSize: '1rem',
    padding: '12px 40px',
    borderRadius: 8,
    boxShadow: '0 4px 15px rgba(34, 109, 104, 0.3)',
    textTransform: 'none',
    width: '100%',
    marginTop: theme.spacing(2),
    '&:hover': {
      background: 'linear-gradient(135deg, #1a5a55 0%, #226D68 100%)',
      boxShadow: '0 6px 20px rgba(34, 109, 104, 0.4)',
    },
    '&:disabled': {
      background: '#cbd5e1',
      boxShadow: 'none',
    },
  },
  formHeader: {
    textAlign: 'center',
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
  },
  formTitle: {
    fontWeight: 700,
    color: '#226D68',
    marginBottom: theme.spacing(1),
    fontSize: '1.5rem',
  },
  formSubtitle: {
    color: '#64748b',
    fontSize: '0.9rem',
  },
  sectionTitle: {
    fontWeight: 600,
    color: '#226D68',
    marginBottom: theme.spacing(2),
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

const DosageForm = ({ onClose, refresh }) => {
  const classes = useStyles();
  const auth = useSelector((state) => state.auth);

  const initialValues = {
    designation: '', 
  };

  const validationSchema = Yup.object().shape({
    designation: Yup.string().min(2, "Trop court").required("Requis"),
  });

  const onSubmit = async (values, props) => {
    try {
      const dosage = {
        "designation": values.designation.trim(),
        "speudo": auth.nom,
      };

      await DoseService.createDosage(dosage);
      
      toast.success("Dosage ajouté avec succès", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      
      props.resetForm();
      
      // Fermer le dialog et rafraîchir si nécessaire
      if (onClose) onClose();
      if (refresh) refresh();
      
    } catch (error) {
      console.error('Erreur ajout dosage:', error);
      toast.error("❌ Erreur lors de l'ajout du dosage", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  return (
    <Box>
      {/* En-tête du formulaire */}
      <Box className={classes.formHeader}>
        <LocalHospitalIcon style={{ fontSize: 40, color: '#226D68', marginBottom: 8 }} />
        <div className={classes.formTitle}>Nouveau Dosage</div>
        <div className={classes.formSubtitle}>Ajoutez un nouveau dosage pharmaceutique</div>
      </Box>

      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
        {(props) => (
          <Form noValidate className={classes.formContainer}>
            <Grid container spacing={2}>
              
              {/* Informations du dosage */}
              <Grid item xs={12}>
                <div className={classes.sectionTitle}>
                  <EditIcon /> Informations du dosage
                </div>
              </Grid>

              {/* Désignation du dosage */}
              <Grid item xs={12} className={classes.gridItem}>
                <Field 
                  as={TextField} 
                  name='designation' 
                  label='Désignation du dosage' 
                  fullWidth 
                  variant="outlined"
                  size="small"
                  error={props.errors.designation && props.touched.designation}
                  helperText={<ErrorMessage name='designation' />} 
                  required 
                  InputProps={{
                    startAdornment: <EditIcon className={classes.iconAdornment} />
                  }}
                  placeholder="Ex: 500mg, 10ml, etc."
                />
              </Grid>

              {/* Bouton de soumission */}
              <Grid item xs={12} className={classes.gridItem}>
                <Button 
                  type='submit' 
                  variant='contained'
                  className={classes.submitButton}
                  startIcon={<AddIcon />}
                  disabled={props.isSubmitting}
                >
                  {props.isSubmitting ? 'Ajout en cours...' : 'Ajouter le dosage'}
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
}

export default DosageForm;